export enum Faction
{
	PLAYER,
	NEUTRAL,
	ENEMY,
	HAZARD,
  RESOURCE,
}

export function getFactionTargetGroups(faction: Faction): Array<number>
{
  const match = {
    [Faction.PLAYER]: [Faction.ENEMY, Faction.HAZARD],
    [Faction.NEUTRAL]: [Faction.ENEMY, Faction.HAZARD],
    [Faction.ENEMY]: [
      Faction.PLAYER,
      Faction.NEUTRAL,
      Faction.HAZARD,
    ],
    [Faction.HAZARD]: [
      Faction.PLAYER,
      Faction.NEUTRAL,
      Faction.ENEMY,
    ],
    [Faction.RESOURCE]: [
      Faction.PLAYER,
    ]
  };
  return match[faction];
}
